import { Component, inject, signal } from '@angular/core';
import { PageContent } from "../../shared/page-content/page-content.component";
import { email, form, required, FormField } from '@angular/forms/signals';
import { Logger } from '../../../logging/logger';
import { Router } from '@angular/router';

type SubmitResponse = {
  success: boolean;
};

@Component({
  selector: 'app-contact',
  imports: [PageContent, FormField],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class Contact {
  private readonly logger = inject(Logger);
  private readonly router = inject(Router);

  protected readonly submitted = signal(false);

  protected readonly formData = signal({
    name: '',
    email: '',
    details: ''
  });
  protected readonly form = form(this.formData, schemaPath => {
    required(schemaPath.name);
    required(schemaPath.email);
    email(schemaPath.email);
    required(schemaPath.details);
  });

  async submit() {
    this.submitted.set(true);

    this.logger.logEvent('Submit', {
      ts: Date.now()
    });

    const result = await fetch('/api/HttpPost', {
      method: 'POST',
      body: JSON.stringify(this.form().value())
    });
    const response: SubmitResponse = await result.json();

    this.form().setControlValue({
      name: '',
      email: '',
      details: ''
    });

    if (response.success) {
      await this.router.navigateByUrl('/contact/success');
    }
  }
}
